.header-container {
    padding: 12px 20px;
    background-color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    /* Matches the min width of the lead page content + sidebar */
    min-width: 1224px; /* content = 800px, sidebar = 400px, content gap = 8px, side padding = 8px * 2 */
}

.left-section {
    min-width: 400px;
}

.right-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
    min-width: 400px;
}

.button-row {
    height: 64px;
    display: flex;
    gap: 8px;
    align-items: center;
}

.lead-value-container {
    margin-right: 40px;
}

.select-row-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 378px;
}

.select-row {
    display: flex;
    gap: 8px;
}

.assignee-button {
    width: 250px;
}
